import React, { useState } from 'react';
import { formValueSelector } from 'redux-form';
import { useSelector, connect } from 'react-redux';
import { changeStepForm, STEPS } from '../../redux/actions/PasosFormulario';
import { API_SERVER } from '../../helpers/URLs';
import '../../sass/RowsRule.scss';
import moment from 'moment';
const selector = formValueSelector('FormDataCliente')

const FormConfirmacion = ({ datosCliente, stepBackward, stepConfirmacion }) => {
    const reservacion = useSelector(state => state.reservacion);
    const vehiculo = useSelector(state => state.vehiculo);
    const coberturas = useSelector(state => state.coberturas);
    const servicios = useSelector(state => state.servicios);
    const fronteras = useSelector(state => state.fronteras);
    const { stepWay } = useSelector(state => state.pasosReservacion);
    const { Cambio } = useSelector(state => state.moneda);
    const [procesando, setProcesando] = useState(false);

    let nombreSiguienteBoton = "RESERVAR";
    let nombreSiguienteBotonProceso = "RESERVANDO";

    if(stepWay === "WAY_COTIZAR"){
        nombreSiguienteBoton = "ENVIAR COTIZACIÓN";
        nombreSiguienteBotonProceso = "ENVIANDO COTIZACIÓN";
    }

    reservacion.DiasDescuento = calcularDiasSolapados(reservacion.FechaRecepcion, reservacion.FechaDevolucion, vehiculo.Desde, vehiculo.Hasta)


    const handleSubmit = () => {
        //console.log("submit form ");
        /* Solicitud a API */
        const solicitud = {
            "TipoOperacion": stepWay,
            "Nombre": datosCliente.nombres,
            "Apellido": datosCliente.apellidos,
            "Edad": datosCliente.edad,
            "Correo": datosCliente.correo,
            "CodigoPostal": datosCliente.codPostal,
            "Telefono": datosCliente.telefono,
            "Observaciones": datosCliente.comentarios,
            "NoVuelo": datosCliente.noVuelo,
            "Aerolinea": datosCliente.aerolinea,
            "FechaVuelo": datosCliente.fechaArrivo,
            "IdLugarRecepcionVehiculo": reservacion.LugarRecepcion.Id,
            "IdLugarDevolucionVehiculo": reservacion.LugarDevolucion.Id,
            "FechaHoraRecepcionVehiculo": moment(reservacion.FechaRecepcion).format("YYYY-MM-DD HH:mm"),
            "FechaHoraDevolucionVehiculo": moment(reservacion.FechaDevolucion).format("YYYY-MM-DD HH:mm"),
            "IdLineaVehiculo": vehiculo.Id,
            "TipoVehiculo": vehiculo.Categoria.Id,
            /* cambio por Error de datos en caso de dias de descuento 0 */
            /* "Descuento": vehiculo.Descuento, */
            "Descuento": (reservacion.DiasDescuento === 0) ? 0.0 : vehiculo.Descuento,
            "IdTransmision": vehiculo.Transmision.Id,
            "CostoTarifa": vehiculo.Precio,
            "DiasDescuento": reservacion.DiasDescuento, 
            "CambioDolar": Cambio,
            "Modelo": vehiculo.Modelo,
            "TotalCosto": (
                (((vehiculo.Precio * reservacion.Dias) - ((vehiculo.Precio * reservacion.DiasDescuento) * (vehiculo.Descuento / 100)))
                    + ((coberturas.length > 0) ? coberturas.reduce((total, cob) => total += (cob.Seleccionado) && cob.Precio * reservacion.Dias, 0) : 0)
                    + ((servicios.length > 0) ? servicios.reduce((total, cob) => total += (cob.Seleccionado) && cob.Precio * reservacion.Dias, 0) : 0)
                    + ((fronteras.length > 0) ? fronteras.reduce((total, cob) => total += (cob.Seleccionado) && cob.Precio, 0) : 0))
            ),
            "TotalSinDescuento": ((vehiculo.Precio * reservacion.Dias)
                + ((coberturas.length > 0) ? coberturas.reduce((total, cob) => total += (cob.Seleccionado) && cob.Precio * reservacion.Dias, 0) : 0)
                + ((servicios.length > 0) ? servicios.reduce((total, cob) => total += (cob.Seleccionado) && cob.Precio * reservacion.Dias, 0) : 0)
                + ((fronteras.length > 0) ? fronteras.reduce((total, cob) => total += (cob.Seleccionado) && cob.Precio, 0) : 0)
            ),
            "TotalDias": reservacion.Dias,
            "Coberturas": coberturas.filter(w => w.Seleccionado).map(val => ({
                "IdCobertura": val.Id,
                "PrecioDia": val.Precio,
                "SubTotal": val.Precio * reservacion.Dias
            })),
            "TotalSinDescuentoUSD": (
                (((vehiculo.Precio * reservacion.Dias)
                    + ((coberturas.length > 0) ? coberturas.reduce((total, cob) => total += (cob.Seleccionado) && cob.Precio * reservacion.Dias, 0) : 0)
                    + ((servicios.length > 0) ? servicios.reduce((total, cob) => total += (cob.Seleccionado) && cob.Precio * reservacion.Dias, 0) : 0)
                    + ((fronteras.length > 0) ? fronteras.reduce((total, cob) => total += (cob.Seleccionado) && cob.Precio, 0) : 0)) / Cambio)
            ),
            "TotalDolar": ((
                (((vehiculo.Precio * reservacion.Dias) - ((vehiculo.Precio * reservacion.DiasDescuento) * (vehiculo.Descuento / 100)))
                    + ((coberturas.length > 0) ? coberturas.reduce((total, cob) => total += (cob.Seleccionado) && cob.Precio * reservacion.Dias, 0) : 0)
                    + ((servicios.length > 0) ? servicios.reduce((total, cob) => total += (cob.Seleccionado) && cob.Precio * reservacion.Dias, 0) : 0)
                    + ((fronteras.length > 0) ? fronteras.reduce((total, cob) => total += (cob.Seleccionado) && cob.Precio, 0) : 0)) / Cambio)
            ),
            "Servicios": servicios.filter(w => w.Seleccionado).map(val => ({
                "IdServicio": val.Id,
                "PrecioDia": val.Precio,
                "SubTotal": val.Precio * reservacion.Dias
            })),
            "Fronteras": fronteras.filter(w => w.Seleccionado).map(val => ({
                "IdFrontera": val.Id,
                "Precio": val.Precio
            }))
        }


        setProcesando(true);
        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            mode: 'cors',
            body: JSON.stringify(solicitud)
        };

        //console.log(requestOptions);
        fetch(`${API_SERVER}/Interamerican/Solicitudes`, requestOptions)
            .then(response => {
                const data = response.json();
                
                if (!response.ok) {
                    const error = (data && data.message) || response.status;
                    return Promise.reject(error);
                } else {
                    
                    setProcesando(false)
                    stepConfirmacion()
                }

            })
            .then(response => console.log(response))
            .catch(error => {
                setProcesando(false);
                console.error('There was an error!', error);
            });
    }

    return (
        <>
            <div className="row">
                <div className="col-md-12">
                    <h2>RESUMEN</h2>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12" style={{ height: "20px" }}></div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <h3>INFORMACIÓN DEL CLIENTE</h3>
                </div>
            </div>
            <div className="row">
                <div className="col-md-2">
                    Nombre:
                </div>
                <div className="col-md-10">
                    {`${datosCliente.nombres} ${datosCliente.apellidos}`}
                </div>
            </div>
            <div className="row">
                <div className="col-md-2">
                    E-Mail:
                </div>
                <div className="col-md-10">
                    {datosCliente.correo}
                </div>
            </div>
            <div className="row">
                <div className="col-md-2">
                    Teléfono:
                </div>
                <div className="col-md-10">
                    {`${datosCliente.codPostal} ${datosCliente.telefono}`}
                </div>
            </div>
            <div className="row">
                <div className="col-md-12" style={{ height: "20px" }}></div>
            </div>
            {datosCliente.aerolinea &&
                <>
                    <div className="row">
                        <div className="col-md-12">
                            <h3>DATOS DEL VUELO</h3>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-2">
                            Aerolínea:
                        </div>
                        <div className="col-md-10">
                            {datosCliente.aerolinea}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-2">
                            No. Vuelo:
                        </div>
                        <div className="col-md-10">
                            {datosCliente.noVuelo}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-2">
                            Fecha Arrivo:
                        </div>
                        <div className="col-md-10">
                            {moment(datosCliente.fechaArrivo).format("LL")}
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-2">
                            Hora Arrivo:
                        </div>
                        <div className="col-md-10">
                            {moment(datosCliente.fechaArrivo).format("hh:mm a")}
                        </div>
                    </div>
                </>
            }
            <div className="row">
                <div className="col-md-12" style={{ height: "20px" }}></div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <h3>COMENTARIOS</h3>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12" style={{ height: "75px", wordWrap: "break-word" }}>
                    {datosCliente.comentarios}
                </div>
            </div>
            <div className="row">
                <div className="col-md-12" style={{ height: "20px" }}></div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <h3>RECEPCIÓN DEL VEHÍCULO</h3>
                </div>
            </div>
            <div className="row">
                <div className="col-md-2">
                    Lugar:
                </div>
                <div className="col-md-10">
                    {reservacion.LugarRecepcion.Direccion}
                </div>
            </div>
            <div className="row">
                <div className="col-md-2">
                    Fecha:
                </div>
                <div className="col-md-10">
                    {moment(reservacion.FechaRecepcion).format('LL')}
                </div>
            </div>
            <div className="row">
                <div className="col-md-2">
                    Hora:
                </div>
                <div className="col-md-10">
                    {moment(reservacion.FechaRecepcion).format("hh:mm a")}
                </div>
            </div>
            <div className="row">
                <div className="col-md-12" style={{ height: "20px" }}></div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <h3>DEVOLUCIÓN DEL VEHÍCULO</h3>
                </div>
            </div>
            <div className="row">
                <div className="col-md-2">
                    Lugar:
                </div>
                <div className="col-md-10">
                    {reservacion.LugarDevolucion.Direccion}
                </div>
            </div>
            <div className="row">
                <div className="col-md-2">
                    Fecha:
                </div>
                <div className="col-md-10">
                    {moment(reservacion.FechaDevolucion).format("LL")}
                </div>
            </div>
            <div className="row">
                <div className="col-md-2">
                    Hora:
                </div>
                <div className="col-md-10">
                    {moment(reservacion.FechaDevolucion).format("hh:mm a")}
                </div>
            </div>
            <div className="row">
                <div className="col-md-12" style={{ height: "20px" }}></div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <h3>DÍAS DEL ALQUILER</h3>
                </div>
            </div>
            <div className="row">
                <div className="col-md-2">
                    Total:
                </div>
                <div className="col-md-10">
                    {reservacion.Dias}
                </div>
            </div>


            <div className="row">
                <div className="col-md-12" style={{ height: "20px" }}></div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <h3>DATOS DEL VEHÍCULO</h3>
                </div>
            </div>
            <div className="row">
                <div className="col-md-2">
                    Tipo:
                </div>
                <div className="col-md-10">
                    {vehiculo.Categoria.Nombre}
                </div>
            </div>
            <div className="row">
                <div className="col-md-2">
                    Vehículo:
                </div>
                <div className="col-md-10">
                    {vehiculo.Nombre}
                </div>
            </div>
            <div className="row">
                <div className="col-md-2">
                    Transmisión:
                </div>
                <div className="col-md-10">
                    {vehiculo.Transmision.Nombre}
                </div>
            </div>
            <div className="row">
                <div className="col-md-12" style={{ height: "20px" }}></div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <h3>TARIFA DEL ALQUILER</h3>
                </div>
            </div>
            <div className="row">
                <div className="col-md-8">
                    Diaria
                </div>
                <div className="col-md-2">
                    <small>
                        Q{vehiculo.Precio.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} x {reservacion.Dias} días
                    </small>
                </div>
                <div className="col-md-2 price-tag">
                    Q{(vehiculo.Precio * reservacion.Dias).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </div>
            </div>
            {vehiculo.Descuento > 0 &&
                <div className="row">
                    <div className="col-md-8">
                        {vehiculo.Descuento}% OFF
                    </div>
                    <div className="col-md-2">
                        <small>
                            {vehiculo.Descuento}% OFF x {

                                reservacion.DiasDescuento

                            } días

                        </small>
                    </div>
                    <div className="col-md-2 price-tag price-red">
                        - Q{(vehiculo.Precio * reservacion.DiasDescuento * (vehiculo.Descuento / 100)).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </div>
                </div>
            }
            {vehiculo.Descuento > 0 &&
                <div className="row">
                    <div className="col-md-10">
                        Diaria con Descuento
                    </div>
                    <div className="col-md-2 price-tag">
                        Q{((vehiculo.Precio * reservacion.Dias) - (vehiculo.Precio * reservacion.DiasDescuento * (vehiculo.Descuento / 100))).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </div>
                </div>
            }
            <div className="row line-bill">
                <div className="col-md-12"><hr /></div>
            </div>
            <div className="row">
                <div className="col-md-12" style={{ height: "20px" }}></div>
            </div>
            {
                coberturas.find(w => w.Seleccionado) &&
                <div className="row">
                    <div className="col-md-12">
                        <h3>COBERTURAS</h3>
                    </div>
                </div>
            }
            {
                coberturas.filter(w => w.Seleccionado).map(val =>
                    <div key={val.Id} className="row">
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-8">
                                    {val.Descripcion}
                                </div>
                                <div className="col-md-2">
                                    <small>
                                        Q{val.Precio.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} x {reservacion.Dias} días
                                    </small>
                                </div>
                                <div className="col-md-2 price-tag">
                                    Q{(val.Precio * reservacion.Dias).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </div>
                            </div>
                            <div className="row line-bill">
                                <div className="col-md-12"><hr /></div>
                            </div>
                        </div>
                    </div>
                )
            }
            {
                servicios.find(w => w.Seleccionado) &&
                <div className="row">
                    <div className="col-md-12" style={{ height: "20px" }}></div>
                </div>
            }
            {
                servicios.find(w => w.Seleccionado) &&
                <div className="row">
                    <div className="col-md-12">
                        <h3>SERVICIOS</h3>
                    </div>
                </div>
            }
            {
                servicios.filter(w => w.Seleccionado).map(val =>
                    <div key={val.Id} className="row">
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-8">
                                    {val.Descripcion}
                                </div>
                                <div className="col-md-2">
                                    <small>
                                        Q{val.Precio.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} x {reservacion.Dias} días
                                    </small>
                                </div>
                                <div className="col-md-2 price-tag">
                                    Q{(val.Precio * reservacion.Dias).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </div>
                            </div>
                            <div className="row line-bill">
                                <div className="col-md-12"><hr /></div>
                            </div>
                        </div>
                    </div>
                )
            }
            {
                fronteras.find(w => w.Seleccionado) &&
                <div className="row">
                    <div className="col-md-12" style={{ height: "20px" }}></div>
                </div>
            }
            {
                fronteras.find(w => w.Seleccionado) &&
                <div className="row">
                    <div className="col-md-12">
                        <h3>CRUCE DE FRONTERAS</h3>
                    </div>
                </div>
            }
            {
                fronteras.filter(w => w.Seleccionado).map(val =>
                    <div key={val.Id} className="row">
                        <div className="col-md-12">
                            <div className="row">
                                <div className="col-md-9">
                                    {val.Descripcion}
                                </div>
                                <div className="col-md-3 price-tag">
                                    Q{(val.Precio).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                </div>
                            </div>
                            <div className="row line-bill">
                                <div className="col-md-12"><hr /></div>
                            </div>
                        </div>
                    </div>
                )
            }
            <div className="row line-bill-bold">
                <div className="col-md-12"><hr /></div>
            </div>
            <div className="row">
                <div className="col-md-9">
                    <h3>TOTAL A PAGAR (GTQ)</h3>
                </div>
                <div className="col-md-3 price-bold-red">
                    <h3>Q{(
                        (((vehiculo.Precio * reservacion.Dias) - ((vehiculo.Precio * reservacion.DiasDescuento) * (vehiculo.Descuento / 100)))
                            + ((coberturas.length > 0) ? coberturas.reduce((total, cob) => total += (cob.Seleccionado) && cob.Precio * reservacion.Dias, 0) : 0)
                            + ((servicios.length > 0) ? servicios.reduce((total, cob) => total += (cob.Seleccionado) && cob.Precio * reservacion.Dias, 0) : 0)
                            + ((fronteras.length > 0) ? fronteras.reduce((total, cob) => total += (cob.Seleccionado) && cob.Precio, 0) : 0))
                    ).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                    </h3>
                </div>
            </div>
            <div className="row">
                <div className="col-md-9">
                    <h3>TOTAL A PAGAR (USD)</h3>
                </div>
                <div className="col-md-3 price-bold-red">
                    <h3>${((
                        (((vehiculo.Precio * reservacion.Dias ) - ((vehiculo.Precio * reservacion.DiasDescuento) * (vehiculo.Descuento / 100)))
                            + ((coberturas.length > 0) ? coberturas.reduce((total, cob) => total += (cob.Seleccionado) && cob.Precio * reservacion.Dias, 0) : 0)
                            + ((servicios.length > 0) ? servicios.reduce((total, cob) => total += (cob.Seleccionado) && cob.Precio * reservacion.Dias, 0) : 0)
                            + ((fronteras.length > 0) ? fronteras.reduce((total, cob) => total += (cob.Seleccionado) && cob.Precio, 0) : 0)) / Cambio)
                    ).toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</h3>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12 box-buttons">
                    <button type="button" onClick={() => stepBackward()} className="btn btn-interamerican">ANTERIOR</button>
                    <button 
                        type="button" 
                        onClick={() => handleSubmit()} 
                        className="btn btn-interamerican" 
                        disabled={procesando}
                        >
                        {
                            !procesando ? nombreSiguienteBoton :
                            <p className="mb-0 d-flex align-items-center gap-2">
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            {nombreSiguienteBotonProceso}
                            </p>
                        }
                        </button>
                </div>
            </div>
        </>
    )
}

const mapStateToProps = state => ({
    datosCliente: {
        nombres: selector(state, 'Nombres'),
        apellidos: selector(state, 'Apellidos'),
        correo: selector(state, 'Correo'),
        codPostal: selector(state, 'CodPostal'),
        telefono: selector(state, 'Telefono'),
        edad: selector(state, 'Edad'),
        comentarios: selector(state, 'Comentarios'),
        aerolinea: selector(state, 'Aerolinea'),
        noVuelo: selector(state, 'NoVuelo'),
        fechaArrivo: selector(state, 'FechaArrivo'),
    }
})

/* function calcularDiasSolapados(fechaHoraInicio1, fechaHoraFin1, fechaHoraInicio2, fechaHoraFin2) {
    const inicio1 = new Date(fechaHoraInicio1);
    const fin1 = new Date(fechaHoraFin1);
    const inicio2 = new Date(fechaHoraInicio2);
    const fin2 = new Date(fechaHoraFin2);
  
    if (inicio2 >= fin1 || fin2 <= inicio1) {
      // No hay solapamiento
      return 0;
    }
  
    const milisegundosSolapados = Math.min(fin1, fin2) - Math.max(inicio1, inicio2);
    const diasSolapados = Math.trunc(milisegundosSolapados / 86400000);
  
    return diasSolapados;
  } */

  function calcularDiasSolapados(fechaHoraInicio1, fechaHoraFin1, fechaHoraInicio2, fechaHoraFin2) {
    const inicio1 = new Date(fechaHoraInicio1);
    const fin1 = new Date(fechaHoraFin1);
    const inicio2 = new Date(fechaHoraInicio2);
    const fin2 = new Date(fechaHoraFin2);

    //console.log("------------------------------i1")
    //console.log(inicio1)
    //console.log(fin1)
    //console.log(inicio2)
    //console.log(fin2)
    //console.log("------------------------------f1")

    fin2.setHours(23);
    fin2.setMinutes(59);
    fin2.setSeconds(59);

    if (inicio2 >= fin1 || fin2 <= inicio1) {
      return 0;
    }

    inicio2.setHours(inicio1.getHours());
    inicio2.setMinutes(inicio1.getMinutes());
    inicio2.setSeconds(inicio1.getSeconds());

    //console.log("------------------------------i2")
    //console.log(inicio1)
    //console.log(fin1)
    //console.log(inicio2)
    //console.log(fin2)
    //console.log("------------------------------f2")

    const milisegundosSolapados = Math.min(fin1, fin2) - Math.max(inicio1, inicio2);
    const diasSolapados = Math.ceil(milisegundosSolapados / 86400000);

    return diasSolapados;
  }

const mapDispatchToProps = dispatch => ({
    stepBackward: () => {
        dispatch(changeStepForm({ stepForm: STEPS.DATOS_CLIENTE }));
        window.scrollTo(0, 0);
    },
    stepConfirmacion: () => {
        dispatch(changeStepForm({ stepForm: STEPS.FINAL }));
        window.scrollTo(0, 0);
    }
})



export default connect(mapStateToProps, mapDispatchToProps)(FormConfirmacion)
